export default { sha: '5a95814949590ef1b72f55a5175ce95693b7ff67', buildNumber: 'undefined' }
